import { CrudList } from '../shared/CrudPage';
import { bankService } from '@kss/api';
import type { Bank, BankCreate, BankFilter } from '@kss/api';

export default function AllBanks() {
  return (
    <CrudList<Bank, BankCreate, BankFilter>
      title="Banks"
      newLabel="New bank"
      service={bankService}
      idKey="bankId"
      labelKey="name"
      basePath="/panel/banks"
      columns={[
        { accessor: 'code', title: 'Code', width: 120 },
        { accessor: 'name', title: 'Name', sortable: true, filterable: true },
        { accessor: 'swiftCode' as never, title: 'SWIFT', width: 140 },
        { accessor: 'ifscPrefix' as never, title: 'IFSC prefix', width: 140 },
      ]}
    />
  );
}
